import styled from 'styled-components'
import { pick, compose, isNil } from 'ramda'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${props => props.count && 'align-items: center;'}
  ${props => props.count && 'flex-basis: 50%;'}
  height: 300px;
  ${props => props.noHeight && 'height: auto;'}
  width: 100%;
  @media screen and (max-width: 992px) {
    ${props => props.count && 'flex-basis: 90%;'}
  }
`

export const Title = styled.p`
  text-transform: uppercase;
  color: ${props => props.theme.colors.blueGrey};
  font-family: ${props => props.theme.fonts.Montserrat};
  font-size: ${props => props.fontSize || '14'}px;
  font-weight: 500;
  padding: 30px 0 0 10px;
`

export const Text = styled.p`
  font-family: ${props => props.theme.fonts.Montserrat};
  font-size: 12px;
  font-weight: ${props => props.fw || '500'};
  color: ${props => props.theme.colors.primary};
  align-self: center;
  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
`

export const getCredentialElements = pick(['personalAwards', 'officialAwards', 'personalCertifications', 'officialCertifications', 'expertise', 'personalAffiliations', 'officialAffiliations'])

export const mergePersonalAndOfficial = (elements) => {
  const personalAwards = elements.personalAwards || []
  const officialAwards = elements.officialAwards || []
  const personalCertifications = elements.personalCertifications || []
  const officialCertifications = elements.officialCertifications || []
  const personalAffiliations = elements.personalAffiliations || []
  const officialAffiliations = elements.officialAffiliations || []
  return ({
    awards: personalAwards.concat(officialAwards),
    certifications: personalCertifications.concat(officialCertifications),
    affiliations: personalAffiliations.concat(officialAffiliations),
    expertise: elements.expertise
  })
}

export const getElementsArr = compose(
  mergePersonalAndOfficial,
  getCredentialElements
)

export const possibleSections = ['personalAwards', 'officialAwards', 'personalCertifications', 'officialCertifications', 'expertise', 'personalAffiliations', 'officialAffiliations']

export const hasCredentials = data => possibleSections.some(value => data[value] && data[value].length > 0)

export const hasOnlyOneSection = (data) => Object.keys(data).reduce((acc, val) => (!isNil(data[val]) && data[val].length) ? acc + 1 : acc, 0) === 1

export const getTitle = {
  'awards': 'AWARDS & HONORS',
  'certifications': 'CERTIFICATIONS',
  'affiliations': 'AFFILIATIONS'
}

export const getSubtitle = {
  'awards': 'AWARD/HONOR NAME',
  'certifications': 'CERTIFICATION NAME',
  'affiliations': 'AFFILIATION NAME'
}

export const InfoWrapper = styled.div`
  padding: 10px;
  margin-right: 5px;
`
